import {
	DollarCircleOutlined,
	EllipsisOutlined,
	DeleteOutlined,
	EditOutlined,
} from "@ant-design/icons";
import { Button, Card, Dropdown, Menu, Form } from "antd";
import "./style.css";
import { useEffect, useState } from "react";
import { updateCompanyBasicInformation } from "../../../../actions/companyActions";
import { usePreviousState } from "../../../../utils/customHooks";
import VoiceFormItems from "./voiceFormItems";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

const VoiceCard = ({
	voice,
	deleteHandler,
	isActionProgress,
	voiceList,
	updateCompanyBasicInformation,
	readOnly,
}) => {
	const { t } = useTranslation();
	const [form] = Form.useForm();
	const [isEditable, setIsEditable] = useState(false);
	const prevActionInProgressValue = usePreviousState(isActionProgress);

	useEffect(() => {
		if (!isActionProgress && prevActionInProgressValue) {
			setIsEditable(false);
			form.resetFields();
		}
	}, [isActionProgress]);

	const menu = (
		<Menu>
			{/* <Menu.Item key="edit" onClick={() => editHandler(voice)}> */}
			<Menu.Item
				key="edit"
				onClick={() => {
					setIsEditable(true);
					form.resetFields();
				}}
			>
				<EditOutlined
					style={{ fontSize: "15px", cursor: "pointer", marginRight: "10px" }}
				/>
				{t("projectCard_action_edit")}
			</Menu.Item>
			<Menu.Item key="delete" onClick={() => deleteHandler(voice)}>
				<DeleteOutlined
					style={{ fontSize: "15px", cursor: "pointer", marginRight: "10px" }}
				/>
				{t("projectCard_action_delete")}
			</Menu.Item>
		</Menu>
	);

	const updateVoice = (formValues) => {
		const oldList = voiceList || [];
		const newList = oldList.map((x) => {
			if (x.index === voice.index) {
				x = { ...formValues };
			}
			delete x.index;
			return x;
		});

		updateCompanyBasicInformation({ voiceOfSeniors: [...newList] });
	};

	return (
		<>
			{isEditable ? (
				<div className="voice_card_container">
					<Form
						layout="vertical"
						form={form}
						initialValues={voice && { ...voice }}
						onFinish={updateVoice}
					>
						<VoiceFormItems
							isActionProgress={isActionProgress}
							action={"edit"}
							cancelActionHandler={() => {
								setIsEditable(false);
								form.resetFields();
							}}
						/>
					</Form>
				</div>
			) : (
				<div className="voice_card_container">
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							width: "100%",
						}}
					>
						<div className="voice_card_body_row">
							<div className="header">
								{t("accountSetting_voiceOfSenior_card_name")}
							</div>
							<div className="body">{voice.name}</div>
						</div>
						<div className="voice_card_title_action_container">
							{!readOnly && (
								<Dropdown
									overlay={menu}
									trigger={["click"]}
									key="ellipsis"
									placement="bottomRight"
								>
									<EllipsisOutlined
										style={{ fontSize: "30px", cursor: "pointer" }}
									/>
								</Dropdown>
							)}
						</div>
					</div>
					<div className="voice_card_body_row">
						<div className="header">
							{t("accountSetting_voiceOfSenior_card_position")}
						</div>
						<div className="body">{voice.position}</div>
					</div>
					<div className="voice_card_body_row">
						<div className="header">
							{t("accountSetting_voiceOfSenior_card_year")}
						</div>
						<div className="body">{voice.yearOfEmployment}</div>
					</div>
					<div className="voice_card_body_row">
						<div className="header">
							{t("accountSetting_voiceOfSenior_card_college")}
						</div>
						<div className="body">{voice.collegeName}</div>
					</div>
					<div className="voice_card_body_row textBox">
						<div className="header">
							{t("accountSetting_voiceOfSenior_card_comment")}:
						</div>
						<div className="body preWrap">{voice.comments}</div>
					</div>
				</div>
			)}
		</>
	);
};

const mapStateToProps = (state) => ({
	isActionProgress: state.company.actionInProgress,
});

export default connect(mapStateToProps, { updateCompanyBasicInformation })(
	VoiceCard
);
